import styled from 'styled-components';

export const Avatar = styled.img`
  max-width: 32px;
  max-height: 32px;
  border-radius: 50%;
  margin-right: 16px;
`;

export const LetterAvatar = styled.div<{ pendingInvite?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 16px;
  background-color: #fdbd36;
  color: #ffffff;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 650px) {
    margin-right: 8px;
  }
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const ProductItemContainer = styled(ItemContainer)`
  margin-left: 8px;
`;

type EmailProps = {
  bold?: boolean;
};

export const Email = styled.p<EmailProps>`
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.2px;
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
  margin-top: 0;
  margin-bottom: 0;
  @media (max-width: 650px) {
    font-size: 14px;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: stretch;
  margin-bottom: 24px;
  &:nth-last-child(2) {
    margin-bottom: 48px;
  }

  .ownerAvatar {
    display: flex;
    margin-top: 32px;
  }
`;

export const OwnerPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 650px) {
    width: 100%;
  }
  div:nth-child(2) {
    padding-bottom: 0;
  }
`;

export const FamilyInfo = styled.p`
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.3px;
  margin-bottom: 0px;
`;

export const Link = styled.a`
  cursor: pointer;
  text-decoration: none;
  color: ${props => props.theme.colors?.primary.main.color};
  font-weight: bold;
`;

export const SubTitle = styled.h2`
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.2px;
  color: #333333;
  margin-top: 48px;
  margin-bottom: 24px;
`;

export const SubTitleProducts = styled(SubTitle)`
  font-size: 16px;
  font-family: 'Inter';
  margin-top: 24px;
`;

export const CustomButton = styled.button`
  border: 0;
  border-radius: 180px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 30px;
  padding: 0 10px;
  cursor: pointer;
  background: transparent;
  &:hover {
    background: #eeeeee;
  }
`;
